module.exports = __webpack_public_path__ + "img/shop1.ed47dac7.jpg";